import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from '../components/HomePage/HeroSection';
import GameGrid from '../components/HomePage/GameGrid';
import StatsSection from '../components/HomePage/StatsSection';
import CTASection from '../components/HomePage/CTASection';
import './HomePage.css';

const HomePage = () => {
  const [featuredGames, setFeaturedGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Load featured games
  useEffect(() => {
    const loadGames = async () => {
      try {
        setLoading(true);
        const response = await fetch('/sample.json');
        const data = await response.json();
        const games = data.games || [];
        
        // Get featured games or fallback to first 6
        const motorace = games.find(g => g.name === 'MotoRace');
        const therastack = games.find(g => g.name === 'TheraStack');
        const colorshot = games.find(g => g.name === 'ColorShot');
        
        const featured = [
          motorace,
          therastack, 
          colorshot,
          ...games.filter(g => !['MotoRace', 'TheraStack', 'ColorShot'].includes(g.name))
        ].filter(Boolean).slice(0, 6);
        
        setFeaturedGames(featured);
      } catch (error) {
        console.error('Error loading games:', error);
        // Fallback games
        setFeaturedGames([
          {
            _id: 'motorace',
            name: 'MotoRace',
            description: 'Race through exciting tracks using aerobic fitness, balance, hands movements. Compatible with Kinect and Orbbec Astra sensors for sitting or standing positions.',
            image: [{ uri: '/images/MotoRace.png' }],
            legacyData: { category: 'Racing', tags: ['Aerobic Fitness', 'Balance', 'Hands'] }
          },
          {
            _id: 'therastack',
            name: 'TheraStack',
            description: 'Build and stack blocks to improve strength and coordination. Features biometric tracking and supports multiple body positions for comprehensive therapy.',
            image: [{ uri: '/images/TheraStack.png' }],
            legacyData: { category: 'Building', tags: ['Biometric', 'Hands', 'Strength'] }
          },
          {
            _id: 'colorshot',
            name: 'ColorShot',
            description: 'Target shooting game that enhances aerobic fitness, balance, and hand-eye coordination. Perfect for both sitting and standing therapy sessions.',
            image: [{ uri: '/images/ColorShot.png' }],
            legacyData: { category: 'Shooter', tags: ['Aerobic Fitness', 'Balance', 'Biometric'] }
          }
        ]);
      } finally {
        setLoading(false);
      }
    };

    loadGames();
  }, []);

  // Event handlers
  const handleGameExplore = (game) => {
    navigate('/games');
  };

  const handleBetaAccess = () => {
    // Scroll to beta access or open modal
    window.location.href = '#beta-portal';
  };

  const handleYouTubeVisit = () => {
    window.open('https://www.youtube.com/@enablegames9807', '_blank', 'noopener,noreferrer');
  };

  if (loading) {
    return (
      <div className="homepage-loading" role="status" aria-label="Loading homepage content">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Loading enAble Games...</p>
        </div>
      </div>
    );
  }

  return (
    <main className="homepage" id="main-content">
      {/* Hero Section */}
      <HeroSection
        featuredGames={featuredGames.slice(0, 3)}
        onGameExplore={handleGameExplore}
        onBetaAccess={handleBetaAccess}
      />

      {/* Statistics Section */}
      <StatsSection />

      {/* Featured Games Grid */}
      <GameGrid
        games={featuredGames}
        title="Featured Games"
        onGameClick={handleGameExplore}
        onExploreMore={() => navigate("/games")}
        showExploreButton={true}
      />

      {/* Call to Action Section */}
      <CTASection
        onBetaAccess={handleBetaAccess}
        onYouTubeVisit={handleYouTubeVisit}
        showVideo={true}
      />
    </main>
  );
};

export default HomePage;